module.exports = __webpack_public_path__ + "img/default_user.ac94c9ca.png";